// extracted by mini-css-extract-plugin
export default {"download_link":"profile-form_download_link__Rtc8y"};